import React, { useState, useEffect, useRef } from 'react';
import './ColumnControl.css';

const ColumnControl = ({ columns, visibleColumns, onToggleColumn }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
  const buttonRef = useRef(null);

  const handleToggle = (columnKey) => {
    onToggleColumn(columnKey);
  };

  const handleSelectAll = () => {
    columns.forEach(col => {
      if (!visibleColumns[col.key]) {
        onToggleColumn(col.key);
      }
    });
  };

  const handleDeselectAll = () => {
    columns.forEach(col => {
      if (visibleColumns[col.key]) {
        onToggleColumn(col.key);
      }
    });
  };

  const visibleCount = Object.values(visibleColumns).filter(v => v).length;

  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: buttonRect.bottom + 5,
        right: window.innerWidth - buttonRect.right
      });
    }
  }, [isOpen]);

  return (
    <div className="column-control-container">
      <button
        ref={buttonRef}
        className="btn btn-secondary btn-sm column-control-btn"
        onClick={() => setIsOpen(!isOpen)}
        title="Sütun Kontrolü"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      
      {isOpen && (
        <>
          <div className="column-control-overlay" onClick={() => setIsOpen(false)}></div>
          <div 
            className="column-control-dropdown"
            style={{
              top: `${dropdownPosition.top}px`,
              right: `${dropdownPosition.right}px`
            }}
          >
            <div className="column-control-header">
              <h4>Sütun Seçimi</h4>
              <button className="close-btn" onClick={() => setIsOpen(false)}>×</button>
            </div>
            <div className="column-control-actions">
              <button className="btn-link" onClick={handleSelectAll}>Tümünü Seç</button>
              <button className="btn-link" onClick={handleDeselectAll}>Tümünü Kaldır</button>
            </div>
            <div className="column-control-list">
              {columns.map((column) => (
                <label key={column.key} className="column-control-item">
                  <input
                    type="checkbox"
                    checked={visibleColumns[column.key] === true}
                    onChange={() => handleToggle(column.key)}
                  />
                  <span>{column.label}</span>
                </label>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ColumnControl;

